export default __webpack_public_path__ + "static/media/ant.f7242c80.svg";